import React from 'react';
import PropTypes from 'prop-types';
import { TestableChip } from '@components/general/TestableComponents';
import { getPassFailChipClassNames } from '@datahooks/metadata/DataUtils';

const PassFailChip = ({ result, label, className = '', dataTestId = 'pass-fail-chip' }) => {
  const text = label ?? result;
  return (
    <TestableChip dataTestId={dataTestId} className={`${getPassFailChipClassNames(result)} ${className}`.trim()} value={text}>
      {text}
    </TestableChip>
  );
};

PassFailChip.propTypes = {
  result: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default PassFailChip;
